import * as React from 'react';
import { memo } from 'react';

const AverageRating = () => (
  <svg
    width="41"
    height="40"
    viewBox="0 0 41 40"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M31.4371 13.9693C31.8737 13.1209 33.0976 13.1209 33.5342 13.9693L35.0052 16.8279C35.0296 16.8753 35.0755 16.9083 35.1285 16.9167L38.3261 17.421C39.2745 17.5706 39.6524 18.7215 38.9742 19.395L36.6851 21.668C36.6472 21.7057 36.6297 21.7589 36.6381 21.8115L37.1427 24.9838C37.2922 25.924 36.3023 26.6356 35.446 26.2036L32.562 24.7486C32.5141 24.7244 32.4573 24.7244 32.4093 24.7486L29.5254 26.2036C28.669 26.6356 27.6792 25.924 27.8287 24.9838L28.3332 21.8115C28.3416 21.7589 28.3241 21.7057 28.2862 21.668L25.9971 19.395C25.319 18.7215 25.6969 17.5706 26.6453 17.421L29.8428 16.9167C29.8959 16.9083 29.9417 16.8753 29.9661 16.8279L31.4371 13.9693Z"
      fill="white"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M9.53421 13.9693L10.7245 16.2823L8.20186 16.6802C6.65663 16.9239 6.02102 18.8139 7.1421 19.9272L9.21893 21.9895L8.7639 24.8505L8.56201 24.7486C8.51408 24.7244 8.45728 24.7244 8.40934 24.7486L5.52536 26.2036C4.66904 26.6356 3.67917 25.924 3.8287 24.9838L4.33324 21.8115C4.34159 21.7589 4.32412 21.7057 4.2862 21.668L1.99713 19.395C1.31896 18.7215 1.69688 17.5706 2.64528 17.421L5.84279 16.9167C5.89588 16.9083 5.94172 16.8753 5.96614 16.8279L7.43714 13.9693C7.87374 13.1209 9.09761 13.1209 9.53421 13.9693Z"
      fill="white"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M21.5342 13.9693L22.7245 16.2823L20.2019 16.6802C18.6566 16.9239 18.021 18.8139 19.1421 19.9272L21.2189 21.9895L20.7639 24.8505L20.562 24.7486C20.5141 24.7244 20.4573 24.7244 20.4093 24.7486L17.5254 26.2036C16.669 26.6356 15.6792 25.924 15.8287 24.9838L16.3332 21.8115C16.3416 21.7589 16.3241 21.7057 16.2862 21.668L13.9971 19.395C13.319 18.7215 13.6969 17.5706 14.6453 17.421L17.8428 16.9167C17.8959 16.9083 17.9417 16.8753 17.9661 16.8279L19.4371 13.9693C19.8737 13.1209 21.0976 13.1209 21.5342 13.9693Z"
      fill="white"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M15.5342 13.9693L16.7245 16.2823L14.2019 16.6802C12.6566 16.9239 12.021 18.8139 13.1421 19.9272L15.2189 21.9895L14.7639 24.8505L14.562 24.7486C14.5141 24.7244 14.4573 24.7244 14.4093 24.7486L11.5254 26.2036C10.669 26.6356 9.67917 25.924 9.8287 24.9838L10.3332 21.8115C10.3416 21.7589 10.3241 21.7057 10.2862 21.668L7.99713 19.395C7.31896 18.7215 7.69688 17.5706 8.64528 17.421L11.8428 16.9167C11.8959 16.9083 11.9417 16.8753 11.9661 16.8279L13.4371 13.9693C13.8737 13.1209 15.0976 13.1209 15.5342 13.9693Z"
      fill="white"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M27.5342 13.9693L28.7245 16.2823L26.2019 16.6802C24.6566 16.9239 24.021 18.8139 25.1421 19.9272L27.2189 21.9895L26.7639 24.8505L26.562 24.7486C26.5141 24.7244 26.4573 24.7244 26.4093 24.7486L23.5254 26.2036C22.669 26.6356 21.6792 25.924 21.8287 24.9838L22.3332 21.8115C22.3416 21.7589 22.3241 21.7057 22.2862 21.668L19.9971 19.395C19.319 18.7215 19.6969 17.5706 20.6453 17.421L23.8428 16.9167C23.8959 16.9083 23.9417 16.8753 23.9661 16.8279L25.4371 13.9693C25.8737 13.1209 27.0976 13.1209 27.5342 13.9693Z"
      fill="white"
    />
  </svg>
);

const Memo = memo(AverageRating);
export default Memo;
